export default [
    '$translate',
    '$state',
    function ($translate, $state) {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                groupReceiver: '=eeeGroupReceiver',
                contactReceiver: '=?eeeContactReceiver',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.click = () => {
                        $state.go('messenger.home.conversation', {
                            type: 'group',
                            id: this.groupReceiver.id,
                            initParams: null,
                        });
                    };
                    this.$onInit = function () {
                        this.showRoleIcon = this.contactReceiver !== undefined;
                        if (this.showRoleIcon) {
                            if (this.contactReceiver.id === this.groupReceiver.administrator) {
                                this.roleIcon = 'people';
                                $translate('messenger.GROUP_ROLE_CREATOR')
                                    .then((label) => this.roleName = label);
                            }
                            else {
                                this.roleIcon = 'people_outline';
                                $translate('messenger.GROUP_ROLE_NORMAL')
                                    .then((label) => this.roleName = label);
                            }
                        }
                    };
                }],
            template: `
                <div class="group-badge receiver-badge" ng-click="ctrl.click()">
                    <section class="avatar-box">
                        <eee-avatar eee-receiver="ctrl.groupReceiver"
                                    eee-resolution="'low'"></eee-avatar>
                    </section>
                    <div class="receiver-badge-name"
                        ng-bind-html="ctrl.groupReceiver.displayName | escapeHtml | emojify">
                    </div>
                    <div class="receiver-role" ng-if="ctrl.showRoleIcon" title="{{ctrl.roleLabel}}">
                        <md-icon aria-label="{{ctrl.roleLabel}}"  class="material-icons md-24">
                            {{ctrl.roleIcon}}
                        </md-icon>
                    </div>

                </div>
            `,
        };
    },
];
